import 'uni-pages';
import Vue from 'vue'
import Page from './pages/personalCenter/activity/list.vue'
createPage(Page)